import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddQuestion from "../../../containers/superadmin/questions-bank/models/add-question";
import SearchBar from "../../../containers/superadmin/questions-bank/searchbar";
import QuestionsBankTable from "../../../containers/superadmin/questions-bank/table";
import { getQuestionBankByBucketRequest } from "../../../modules/superadmin-modules/questions-bank/Actions";
const SuperadminQuestionsBank = () => {
  const dispatch = useDispatch();
  const model = useSelector((state) => state.model);
  const [isAdd, setAdd] = useState(false);
  const [bucketId, setBucketId] = useState(false);

  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    if (bucketId) dispatch(getQuestionBankByBucketRequest(bucketId));
  }, [bucketId]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        setBucketId={setBucketId}
      />
      <QuestionsBankTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <AddQuestion
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default SuperadminQuestionsBank;
